import React from 'react';
import { useTranslation } from 'react-i18next';
import './Settings.css';

interface SettingsProps {
  isVisible: boolean;
  onClose: () => void;
}

const Settings: React.FC<SettingsProps> = ({ isVisible, onClose }) => {
  const { t, i18n } = useTranslation();

  const handleLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  if (!isVisible) return null;

  return (
    <div className="settings-overlay">
      <div className="settings-modal">
        <div className="settings-header">
          <h2>{t('settings.title')}</h2>
          <button className="close-button" onClick={onClose}>✕</button>
        </div>
        <div className="settings-content">
          <div className="settings-section">
            <h3>{t('settings.language')}</h3>
            <div className="language-options">
              <button
                className={`language-button ${i18n.language === 'tr' ? 'active' : ''}`}
                onClick={() => handleLanguageChange('tr')}
              >
                <span className="flag">🇹🇷</span>
                <span className="language-name">Türkçe</span>
              </button>
              <button
                className={`language-button ${i18n.language === 'en' ? 'active' : ''}`}
                onClick={() => handleLanguageChange('en')}
              >
                <span className="flag">🇺🇸</span>
                <span className="language-name">English</span>
              </button>
            </div>
          </div>
          {/* Buraya diğer ayarlar eklenebilir */}
        </div>
      </div>
    </div>
  );
};

export default Settings; 